import React, { useCallback, useState } from 'react';
import cn from 'clsx';

import { ModalFullscreen, UIHeading3 } from '@cian/ui-kit';
import { IconActionArrowLeft24 } from '@cian/ui-kit-design-tokens/icons';

import { useAuthAction } from '../../hooks/useAuthAction';

import { useStuckState } from './utils';
import { OfferCardMobile } from '../../components/OfferCardMobile';
import { OffersSummary } from '../../components/OffersSummary';
import { FillApplicationStickyButton } from '../FillApplicationStickyButton';
import { IMobileListingContainer } from './types';

import * as styles from './styles.css';
import { ETestIds } from '../../constants';
import { useTracking } from '../../utils/tracking/useTracking';

export const MobileListingContainer: React.FC<IMobileListingContainer> = ({
  offerList,
  offerListForAnalytics,
  onCardClick,
  offerSummary,
  isLoading,
}) => {
  const [isListingOpen, setIsListingOpen] = useState(false);
  const [btnRef, setBtnRef] = useState<HTMLElement | null>(null);
  const { stuck } = useStuckState(btnRef);
  const { trackShowOffers, trackClickPskTooltip, trackClickOnTargetButton } = useTracking();
  const { isLoading: isActionLoading, handleAuthAction } = useAuthAction({
    trackingFunction: trackClickOnTargetButton,
  });

  const handleSetFormRef = useCallback((node: HTMLDivElement | null) => {
    setBtnRef(node);
  }, []);

  const handleCtaClick = () => {
    setIsListingOpen(true);
    trackShowOffers(offerListForAnalytics);
  };

  return (
    <>
      <OffersSummary onCtaClick={handleCtaClick} isLoading={isLoading} {...offerSummary} />
      <ModalFullscreen open={isListingOpen} onClose={() => {}} theme={'white'}>
        <div className={styles['listing']} data-testid={ETestIds.MobileListing}>
          <div
            className={cn(styles['return-button'], stuck && styles['stuck'])}
            ref={handleSetFormRef}
            onClick={() => setIsListingOpen(false)}
            data-testid={ETestIds.MobileListingReturnButton}
          >
            <IconActionArrowLeft24 color={'icon-main-default'} />
            <UIHeading3>Ипотечные предложения</UIHeading3>
          </div>
          <div className={styles['listing-wrapper']}>
            <div className={styles['content']}>
              {offerList.map((offer, index) => {
                return (
                  <OfferCardMobile
                    offer={offer}
                    onClick={onCardClick(offer)}
                    trackClickPskTooltip={trackClickPskTooltip}
                    key={index}
                  />
                );
              })}
            </div>
            <FillApplicationStickyButton onClick={handleAuthAction} loading={isActionLoading} />
          </div>
        </div>
      </ModalFullscreen>
    </>
  );
};
